<template>
  <svg :width="size" :height="size" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <!-- Devil trident/pitchfork home icon -->
    <path d="M16 3L3 15h5v12h6v-8h4v8h6V15h5L16 3z" :fill="color" />
    <!-- Devil horns on the roof -->
    <path d="M8 14L5 6" :stroke="color" stroke-width="2.5" stroke-linecap="round" />
    <path d="M24 14L27 6" :stroke="color" stroke-width="2.5" stroke-linecap="round" />
  </svg>
</template>
<script setup lang="ts">
withDefaults(defineProps<{ size?: number; color?: string }>(), {
  size: 28,
  color: '#CC0000',
});
</script>
